export default __webpack_public_path__ + "static/media/poll_icon.c16c8721.svg";